import type { PrayerDay } from "../lib/types";
import { formatTime, weekdayShort } from "../lib/time";
import { useLocale, hijriMonthName } from "../lib/i18n";

export function TimetableTable(props: { days: PrayerDay[]; timeFormat: "24h" | "12h"; title?: string }) {
  const { t, locale, prayerName } = useLocale();
  return (
    <div className="col" style={{ gap: 10 }}>
      {props.title ? <div className="h2">{props.title}</div> : null}
      <div className="tableWrap">
        <table>
          <thead>
            <tr>
              <th className="sticky">{t.thDate}</th>
              <th>{prayerName("fajr")}</th>
              <th>{prayerName("sunrise")}</th>
              <th>{prayerName("dhuhr")}</th>
              <th>{prayerName("asr")}</th>
              <th>{prayerName("maghrib")}</th>
              <th>{prayerName("isha")}</th>
              <th>{t.thHijri}</th>
            </tr>
          </thead>
          <tbody>
            {props.days.map((d) => (
              <tr key={d.dateGregorianISO}>
                <td className="sticky">
                  <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <div style={{ fontWeight: 700 }}>
                      {weekdayShort(d.dateGregorianISO, undefined, locale)} · {d.dateGregorianISO}
                    </div>
                    <div style={{ color: "var(--muted)", fontSize: 12 }}>
                      {d.meta.timezone}
                    </div>
                  </div>
                </td>
                <td>{formatTime(d.timings.fajr, props.timeFormat)}</td>
                <td>{formatTime(d.timings.sunrise, props.timeFormat)}</td>
                <td>{formatTime(d.timings.dhuhr, props.timeFormat)}</td>
                <td>{formatTime(d.timings.asr, props.timeFormat)}</td>
                <td>{formatTime(d.timings.maghrib, props.timeFormat)}</td>
                <td>{formatTime(d.timings.isha, props.timeFormat)}</td>
                <td>
                  {d.dateHijri.day} {hijriMonthName(locale, d.dateHijri.month)} {d.dateHijri.year}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
